// extracted by mini-css-extract-plugin
export default {"root":"AccountInfos_root__89Utj"};